import React, { Component } from 'react';

export default class DetalhesManutencaoVeiculo extends Component {

    render() {
        if (!this.props.manutencaoVeiculo.exibirDetalhe) {
            return ''
        }
        return (
            <div className="card-body cinza-zebrado table-responsive-sm">
                <table className="table table-sm table-bordered">
                    <tbody>
                        <tr style={{backgroundColor: '#ffffff66'}}>
                            <td className='text-center'><strong>Ocorrência</strong></td>
                        </tr>
                        <tr>                            
                            <td>{this.props.manutencaoVeiculo.ocorrencia}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}